jQuery(function () {
	$(".header .nav ul li").hover(function(){
		$(this).find(".sub-nav").css("display","block");
	},function(){
	    $(this).find(".sub-nav").css("display","none");
	});
	// $(".header .apply-data-btn").on("click", function() {
	// 	$(".pop-mask").fadeIn("slow");
	// 	$(".pop-content").fadeIn("slow");
	// });
	// $(".mobile-header .m-box .r-box .apply-data-btn").on("click", function() {
	// 	$(".pop-mask").fadeIn("slow");
	// 	$(".pop-content").fadeIn("slow");
	// });
	// $(".pop-content .close-btn").on("click", function() {
	// 	$(".pop-mask").fadeOut("slow");
	// 	$(".pop-content").fadeOut("slow");
	// });

	// $(".count-btn").on("click", function() {
	// 	var height  = parseFloat($(".higher-num").val());
	// 	var weight  = parseFloat($(".wigher-num").val());
	// 	var result = (weight / ((height*height).toFixed(2))).toFixed(2)
	// 	$(".result-box").html(""+result);
	// });
})

$(function(){
	// $(document).delegate(".close-btn","click", function(){
	// 	$(".index-pop-mask,.pop-mask").fadeOut("slow");
	// 	$(".index-pop-pic,.pop-content").fadeOut("slow");
	// });

	$(document.body).delegate(".to-top","click", function(){
		$("html, body").animate({
			"scroll-top":0
		},"fast");
	});

	$(document.body).delegate(".mobile-header .nav-list li","click", function(){
		$('.sub-nav:visible').slideUp().prev().removeClass('nav-on');
			var subnav = $(this).find('.sub-nav');
			console.log(subnav.is(':hidden'))
			if(subnav.is(':hidden')) {
				subnav.slideDown().prev().addClass('nav-on');
			} else {
				subnav.slideUp().prev().removeClass('nav-on');
			};
	});

	$(document.body).delegate(".mobile-header .nav-btn","click", function(){
		$(".mobile-header .nav-btn").toggleClass("nav-btn-close");
		if($(this).attr("id")=="open"){
			$(".mobile-header .nav-btn").removeAttr("id");
			$(".mobile-header .nav-list").slideUp();
		}else{
			$(".mobile-header .nav-btn").attr("id","open");
			$(".mobile-header .nav-list").slideDown();
			// document.querySelector('.element').addEventListener('touchmove', stopScroll, false);
		}
	});

	// $(document.body).delegate(".mobile-header .m-box .r-box .apply-data-btn","click", function(){
	// 	$(".pop-mask").fadeIn("slow");
	// 	$(".pop-content").fadeIn("slow");
	// });

	// $(document.body).delegate(".header .apply-data-btn","click", function(){
	// 	$(".pop-mask").fadeIn("slow");
	// 	$(".pop-content").fadeIn("slow");
	// });

	// $(document.body).delegate(".count-btn","click", function(){
	// 	var height  = parseFloat($(".higher-num").val());
	// 	var weight  = parseFloat($(".wigher-num").val());
	// 	var result = (weight / ((height*height).toFixed(2))).toFixed(2)
	// 	$(".result-box").html(""+result);
	// });


	$(document.body).delegate(".header .nav ul li","hover", function(){
		$(this).find(".sub-nav").css("display","block");
	},function(){
	    $(this).find(".sub-nav").css("display","none");
	});
})



//////////////////
// WEBPACK FOOTER
// ./static/js/common.js
// module id = /sA3
// module chunks = 0